// import React from "react";
// import "../../Styles/Purchaseorder.css";

// const FormField = ({ label, type = "text", placeholder }) => (
//   <div className="form-field">
//     <label>{label}</label>
//     <input type={type} placeholder={placeholder} className="input" />
//   </div>
// );

// const Masters = () => {
//   return (
//     <div className="purchase-order-form">
//       <div className="card">
//         {/* Section 1 */}
//         <h2>Service Master</h2>
//         <div className="form-grid">
//           <FormField  placeholder="Transfer ID" />
//           <FormField  type="date" label="Date" />
//           <FormField  placeholder="Source Warehouse" />
//           <FormField  placeholder="Destination Warehouse" />
//           <FormField  placeholder="Item" />
//           <FormField  placeholder="Quantity" />
//           <FormField  placeholder="Lot Number" />
//         </div>
//         <div className="form-buttons1">
//         <button className="btn submit">Transfer Stock</button>
//         </div>

//         {/* Section 2 */}
//         <h3>Record Stock Loss / Disposal</h3>
//         <div className="form-grid">
//           <FormField  placeholder="Item" />
//           <FormField  placeholder="Quantity" />
//           <FormField  placeholder="Reason / Tag" />
//           <FormField  placeholder="Warehouse" />
//         </div>
//         <div className="form-buttons1">
//           <button className="btn submit">Record Loss</button>
//         </div>

//         {/* Section 3 */}
//         <h3>Add FG Batch Document</h3>
//         <div className="form-grid">
//           <FormField  placeholder="Batch Number" />
//           <FormField  placeholder="Document Type" />
//           <div className="form-field full-width">
//             <label>Upload File</label>
//             <input type="file" className="input" />
//           </div>
//         </div>
//         <div className="form-buttons1">
//           <button className="btn submit">Upload Document</button>
//         </div>

//         {/* Section 4 */}
//         <h3>View Stock by Lot</h3>
//         <div className="form-grid">
//           <FormField placeholder="Lot Number" />
//           <FormField type="date" label="From Date" />
//           <FormField type="date" label="To Date" />
//         </div>
//         <div className="form-buttons1">
//           <button className="btn submit">Search Stock</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Masters;

import React, { useState } from "react";
import "../../Styles/Purchaseorder.css";
import ApiConfig from "../../../api/ApiConfig";
import { PostCallWithErrorResponse } from "../../../api/ApiServices";
import { ToastMsg } from "../../TostMsg";
import FormField from "../../../component/formFiedl";


const types = [
    {
        value: 'Customer',
        label: 'Customer'
    },
    {
        value: 'Vendor',
        label: 'Vendor'
    },
]



const Section = ({ title, fields, buttonLabel, setFormData, formData, errorMessage, handleSubmit }) => (
    <>
        <h3 >{title}</h3> {/* Styled title */}
        <div className="form-grid">
            {fields.map(({ label, placeholder, key, errorkey, type = 'text', max = null, options, valKey, labelKey }, index) => (
                <FormField key={index} label={label} placeholder={placeholder}
                    value={formData[key]}
                    type={type}
                    onChange={(key, value) => {

                        if (type === 'number' && max && Number(value) > max) {
                            return
                        }

                        setFormData(prev => ({
                            ...prev,
                            [key]: type === 'number' ? Number(value) || '' : value
                        }))
                    }}
                    valKey={key}
                    validationErr={errorMessage[errorkey ? errorkey : key]}
                    options={options}
                    valueKey={valKey}
                    labelKey={labelKey}
                />
            ))}
        </div>
        <div className="form-buttons1">
            <button className="btn action"
                onClick={handleSubmit}
            >{buttonLabel}</button>
        </div>
    </>
);

const Masters = () => {

    const initialService = {
        Id: 0,
        "ServiceName": "",
        "Tags": "",
    }

    const initialMaterialMaster = {
        "Id": 0,
        "MaterialName": "",
        "HSNCode": "",
        "GST": "",
        "Lead": "",
        "LeadCost": "",
        "Tags": "",
        "TestParameter": "",
        "OrgId": 0,
        "IsActive": true
    }

    const initialFinishedGood = {
        "Id": 0,
        "FGName": "",
        "Tags": "",
        "OrgId": 0,
        "EntryBy": 0,
        "IsActive": true
    }

    const initialBundle = {
        "Id": 0,
        "BundleName": "",
        "Tags": "",
        "OrgId": 0,
        "IsActive": true
    }

    const initialWareHouse = {
        "Id": 0,
        "WarehouseName": "",
        "Address": "",
        "GSTIN": "",
        "OrgId": 0,
        "ClientEntityId": 0,
        "EntryBy": 0,
        "IsActive": true
    }

    const intialCusVen = {
        "Id": 0,
        "ShipAddr": "",
        "BillContactNo": "",
        "BillGstNo": "",
        "BillCustName": "",
        "BillAddr": "",
        "Type": "",
        "IsActive": true
    }

    const [errorMessage, setErrorMessage] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [serviceDetails, setServiceDetails] = useState(initialService)
    const [materialMaster, setMaterialMaster] = useState(initialMaterialMaster)
    const [finishedGoodMaster, setFinishedGoodMaster] = useState(initialFinishedGood)
    const [bundleDetails, setBundleDetails] = useState(initialBundle)
    const [wareHouse, setwareHouse] = useState(initialWareHouse)
    const [custmrVendor, setCustVendr] = useState(intialCusVen)





    const handleSubmit = (type = "", apiEndPoint) => {

        if (!type || isLoading) return



        let payload = {}

        let clearData;

        let initialData = {}

        switch (type) {
            case 'ServiceMaster':

                setErrorMessage(prev => ({
                    ...prev,
                    ServiceName: !serviceDetails?.ServiceName ? 'Please Enter Service Name' : "",
                    Tags: !serviceDetails?.Tags ? 'Please Enter Tags' : "",
                }))

                if (!serviceDetails?.ServiceName || !serviceDetails?.Tags) return


                payload = serviceDetails

                clearData = setServiceDetails

                initialData = initialService


                break
            case 'MaterialMaster':

                setErrorMessage(prev => ({
                    ...prev,
                    MaterialName: !materialMaster?.MaterialName ? 'Please Enter Material Name' : "",
                    TagsMaterial: !materialMaster?.Tags ? 'Please Enter Tags' : "",
                    HSNCode: !materialMaster?.HSNCode ? 'Please Enter HSN Code' : '',
                    GST: !materialMaster?.GST ? "Please Enter GST" : "",
                    Lead: !materialMaster?.Lead ? "please Enter Lead" : "",
                    LeadCost: !materialMaster?.LeadCost ? 'Please Enter Lead Cost' : '',
                    TestParameter: !materialMaster?.TestParameter ? "Please enter Test Parameter" : ""


                }))

                if (!materialMaster?.MaterialName || !materialMaster?.Tags || !materialMaster?.HSNCode || !materialMaster?.GST ||
                    !materialMaster?.Lead || !materialMaster?.LeadCost || !materialMaster?.TestParameter) return


                payload = materialMaster

                clearData = setMaterialMaster

                initialData = initialMaterialMaster

                break
            case 'FineshedGood':
                setErrorMessage(prev => ({
                    ...prev,
                    FGName: !finishedGoodMaster?.FGName ? 'Please Enter FG Name ' : "",
                    FinishedTags: !finishedGoodMaster?.Tags ? 'Please Enter Tags' : "",
                }))

                if (!finishedGoodMaster?.FGName || !finishedGoodMaster?.Tags) return


                payload = finishedGoodMaster

                clearData = setFinishedGoodMaster

                initialData = initialFinishedGood
                break
            case "Bundle":
                setErrorMessage(prev => ({
                    ...prev,
                    BundleName: !bundleDetails?.BundleName ? 'Please Enter Bundle Name ' : "",
                    BundleTags: !bundleDetails?.Tags ? 'Please Enter Tags' : "",
                }))

                if (!bundleDetails?.BundleName || !bundleDetails?.Tags) return


                payload = bundleDetails

                clearData = setBundleDetails

                initialData = initialBundle
                break
            case 'wareHouse':
                setErrorMessage(prev => ({
                    ...prev,
                    WarehouseName: !wareHouse?.WarehouseName ? 'Please Enter WareHouse Name ' : "",
                    Address: !wareHouse?.Address ? 'Please Enter Address' : "",
                    GSTIN: !wareHouse?.GSTIN ? 'Please Enter GSTIN Number' : "",
                }))

                if (!wareHouse?.WarehouseName || !wareHouse?.Address || !wareHouse?.GSTIN) return


                payload = wareHouse

                clearData = setwareHouse

                initialData = initialWareHouse
                break;
            case 'VendorCus':

                custmrVendor.BillContactNo = custmrVendor?.BillContactNo + ''

                setErrorMessage(prev => ({
                    ...prev,
                    BillAddr: !custmrVendor?.BillAddr ? 'Please Enter Bill Address  ' : "",
                    BillContactNo: custmrVendor?.BillContactNo?.length !== 10 ? 'Please Enter Valid Number' : "",
                    BillCustName: !custmrVendor?.BillCustName ? 'Please Enter Customer Name' : "",
                    BillGstNo: !custmrVendor?.BillGstNo ? 'Please Enter Bill Gst No' : "",
                    ShipAddr: !custmrVendor?.ShipAddr ? 'Please Enter Ship Address' : "",
                    Type: !custmrVendor?.Type ? 'Please Select Type' : "",
                }))

                if (!custmrVendor?.BillAddr || custmrVendor?.BillContactNo?.length != 10 || !custmrVendor?.BillCustName || !custmrVendor?.BillGstNo || !custmrVendor?.ShipAddr || !custmrVendor?.Type) return


                payload = custmrVendor

                clearData = setCustVendr

                initialData = intialCusVen
                break;
            default:
                return
        }
        setIsLoading(true)

        PostCallWithErrorResponse(apiEndPoint, JSON.stringify(payload)).then((res) => {

            if (res?.json?.success) {
                ToastMsg('success', res?.json?.message)
                clearData(initialData)
            } else {
                ToastMsg('error', res?.json?.message)
            }

            setIsLoading(false)

        })

    }


    return (
        <div className="purchase-order-form">

            <div className="card">
                <Section
                    title="Service Master"
                    buttonLabel="Save Service"
                    fields={[
                        { placeholder: "Service Name", key: "ServiceName" },
                        { placeholder: "Tags (comma separated)", key: "Tags" },
                    ]}
                    setFormData={setServiceDetails}
                    formData={serviceDetails}
                    errorMessage={errorMessage}
                    handleSubmit={() => handleSubmit('ServiceMaster', ApiConfig.CREATE_MASTER_SERVICE)}
                />

                <Section
                    title="Material Master"
                    buttonLabel="Save Material"
                    fields={[
                        { placeholder: "Material Name", key: 'MaterialName' },
                        { placeholder: "HSN Code", key: "HSNCode" },
                        { placeholder: "GST (%)", key: 'GST', type: 'number', max: 100 },
                        { placeholder: "Lead", key: 'Lead' },
                        { placeholder: "Lead Cost", key: 'LeadCost', type: 'number' },
                        { placeholder: "Tags", key: 'Tags', errorkey: 'TagsMaterial' },
                        { placeholder: "Test Parameters (comma separated)", key: 'TestParameter' },
                    ]}
                    setFormData={setMaterialMaster}
                    formData={materialMaster}
                    errorMessage={errorMessage}
                    handleSubmit={() => handleSubmit('MaterialMaster', ApiConfig.CREATE_MATERIAL_MASTER)}
                />


                <Section
                    title="Finished Goods Master"
                    buttonLabel="Save Finished Good"
                    fields={[
                        { placeholder: "FG Name", key: 'FGName', errorkey: "FGName" },
                        { placeholder: "Tags", key: 'Tags', errorkey: 'FinishedTags' },
                    ]}
                    setFormData={setFinishedGoodMaster}
                    formData={finishedGoodMaster}
                    errorMessage={errorMessage}
                    handleSubmit={() => handleSubmit('FineshedGood', ApiConfig.CREATE_FINISHED_GOOD_MASTER)}
                />


                <Section
                    title="Bundle / SKU Master"
                    buttonLabel="Save Bundle"
                    fields={[
                        { placeholder: "Bundle/SKU Name", key: "BundleName" },
                        { placeholder: "Tags", key: "Tags", errorkey: "BundleTags" },
                    ]}
                    setFormData={setBundleDetails}
                    formData={bundleDetails}
                    errorMessage={errorMessage}
                    handleSubmit={() => handleSubmit('Bundle', ApiConfig.CREATE_BUNDLE)}
                />

                <Section
                    title="Warehouse Master"
                    buttonLabel="Save Warehouse"
                    fields={[
                        { placeholder: "Warehouse Name", key: 'WarehouseName' },
                        { placeholder: "Address", key: 'Address' },
                        { placeholder: "GSTIN", key: 'GSTIN' },
                    ]}
                    setFormData={setwareHouse}
                    formData={wareHouse}
                    errorMessage={errorMessage}
                    handleSubmit={() => handleSubmit('wareHouse', ApiConfig.CREATE_WAREHOUSE)}
                />

                <Section
                    title="Vendor / Customer Master"
                    buttonLabel="Save Record"
                    fields={[
                        { placeholder: "Name", key: 'BillCustName' },
                        { placeholder: "Type (Vendor/Customer)", type: "select", key: 'Type', options: types, valKey: 'value', labelKey: 'label' },
                        { placeholder: "GSTIN", key: "BillGstNo" },
                        { placeholder: "Billing Address", key: 'BillAddr' },
                        { placeholder: "Mapping Address", key: 'ShipAddr' },
                        { placeholder: "Contact No", key: 'BillContactNo', type: 'number' },
                    ]}
                    setFormData={setCustVendr}
                    formData={custmrVendor}
                    errorMessage={errorMessage}
                    handleSubmit={() => handleSubmit('VendorCus', ApiConfig.CREATE_VENDOR_CUSTOMER)}
                />
            </div>
        </div>
    );
};

export default Masters;
